import { useState } from 'react'
import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch-hooks-web'
import Search from '@cerifi/ui/components/icons/search'
import { AuditTime } from '@cerifi/ui/utils/audit-time'
import { cn } from '@cerifi/ui/utils/cn'

export function SearchBar(props: UseSearchBoxProps) {
  const { query, refine, clear } = useSearchBox(props)
  const [value, setValue] = useState(query)
  const [auditTime] = useState(new AuditTime((value: string) => refine(value)))

  return (
    <div className={cn('w-full max-w-[50rem]')}>
      <div className="flex items-center border-b border-neutral-800">
        <div className="relative flex-1">
          <input
            aria-label="search"
            className={'bg-backgroundShade-50 w-full py-2 pl-3 pr-6 text-2xl'}
            placeholder="Type to search products, pages, or articles"
            value={value}
            onChange={(v) => {
              setValue(v.target.value)
              auditTime.fire(v.target.value)
            }}
          />

          <div className="absolute inset-y-0 right-0 flex items-center">
            <Search />
          </div>
        </div>
      </div>

      <div className="flex justify-end ">
        {query ? (
          <button
            onClick={() => {
              setValue('')
              clear()
            }}
            className="border-b border-transparent text-neutral-800 hover:border-neutral-500"
          >
            clear
          </button>
        ) : (
          <div className="pt-6"></div>
        )}
      </div>
    </div>
  )
}
